/** @jsx jsx */
import React from 'react';
import { jsx } from '@balance-web/core';
import { Button, ButtonProps } from '@balance-web/button';
import { Flex, FlexProps } from '@balance-web/flex';

export type Action = ButtonProps &
  JSX.IntrinsicAttributes & {
    action: CallableFunction;
  };

export type ActionFooterProps = FlexProps & {
  size?: Action['size'];
  isInsideDrawer?: boolean;
  actions: (Action | undefined)[];
};

export function ActionFooter({
  actions,
  size,
  gap = 'medium',
  isInsideDrawer,
  ...flexProps
}: ActionFooterProps) {
  return (
    <Flex {...flexProps} gap={gap}>
      {actions
        .filter((action): action is Action => !!action)
        .map(({ action, label, weight, tone, ...props }, index) => {
          return (
            <Button
              label={label}
              key={label}
              size={props.size || size || 'small'}
              onClick={() => action()}
              css={{ minWidth: 304 }}
              weight={index ? 'none' : (isInsideDrawer && 'subtle') || 'bold'}
              tone={(index && 'active') || undefined}
              {...props}
            />
          );
        })}
    </Flex>
  );
}
